export const environment = {
  'production': true,
  'proxy': 'https://proxy-dev.swaas.de',
  'mcp': 'https://mcp.swaas.de/',
  'MCP_CLIENTS_JSON': 'https://mcp.swaas.de/clients.json',
  'clientID': 123,
  'apiURL': 'https://vtw-prod-api.plusservices.de',
  'appVersion': require('../../package.json').version,
  'ngVersion': require('../../package.json').dependencies['@angular/pwa'],
  'appName' : 'Stadtwerke Bielefeld Dashboard'
}
